import { IconType } from "@deepguide-ai/types"

// Helper function to get icon style classes based on iconType
export const getIconStyleClasses = (iconType: IconType) => {
  switch (iconType) {
    case 'SOLID':
      return 'fill-current'
    case 'LIGHT':
      return 'stroke-1'
    case 'THIN':
      return 'stroke-1 opacity-75'
    case 'SHARP_SOLID':
      return 'fill-current stroke-2'
    case 'DUOTONE':
      return 'opacity-60'
    case 'BRANDS':
      return 'font-bold'
    case 'REGULAR':
    default:
      return 'stroke-2'
  }
}
